<template>
	<div class="mia-Subject" :class="[subjectClass, {'active': isActive}]" 
		@click="onSubjectClick"
	>
		<span class="mia-mainImage mia-bg-image-subject" :class="subjectBackgroundImageClass" />
		<div class="text-center" :class="subjectBackgroundContrastClass">
			<h6 v-tr="subjectTR" />
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Prop, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "../../../../../Reinforced.Typings";
import SubjectHelper from "../../../../../utils/SubjectHelper";
import { DefaultLandingPageSubjectData } from "../../../Defaults";
import { useSelectedItemStore } from "@/Control/Vue/Stores/SelectedItemStore";
import { Item } from "./Item";

@Component
export class Subject extends Item<MiaPlaza.Controllers.Public.ISubjectData> {
	protected defaults = DefaultLandingPageSubjectData;
	@Prop({ required: true }) protected selectedSubjectStoreName!: string;

	get isActive(): boolean {
		const selectedItemStore =
		useSelectedItemStore(this.selectedSubjectStoreName);
		return (selectedItemStore && selectedItemStore.selected)
			? selectedItemStore.selected.Subject === this.identifier
			: false;
	}

	async onSubjectClick(): Promise<void> {
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		useSelectedItemStore(this.selectedSubjectStoreName).set(this.item);
	}

	get subjectClass() {
		return SubjectHelper.GetBackgroundClass(this.identifier as string);
	}

	get subjectTR() {
		return SubjectHelper.GetTrKey(this.identifier as string);
	}

	get subjectBackgroundImageClass(): string {
		return SubjectHelper.GetBackgroundImageClass(this.identifier as string);
	}

	get subjectBackgroundContrastClass(): string {
		return SubjectHelper.GetBackgroundContrastClass(this.identifier as string);
	}
}

export default toNative(Subject);
</script>
